const normalizeBreadcrumb = (crumb) => {
  return {
    id: null,
    name: null,
    label: null,
    refinementKey: null,
    dimensionName: 'Category',
    ...crumb // what is needed from the breadcrumb??? :sob:
  };
};

const applyPriceRefinement = (priceRefinement, processedRefinements) => {
  if (!priceRefinement) return { pricePart: '', updatedRefinements: processedRefinements };

  const [lowerRaw, upperRaw] = priceRefinement
    .split('-')
    .map((part) => part.replace(/\$/g, '').replace(/,/g, '').trim());

  const lower = Number(lowerRaw);
  const upper = Number(upperRaw);

  if (Number.isNaN(lower) || Number.isNaN(upper)) {
    return { pricePart: '', updatedRefinements: processedRefinements };
  }

  const updatedRefinements = [...processedRefinements];
  const index = updatedRefinements.indexOf(priceRefinement);

  if (index !== -1) {
    updatedRefinements.splice(index, 1); // remove from original position
  }

  if (lower === 0 && upper > 0) {
    return { pricePart: `Under $${upper.toLocaleString()}`, updatedRefinements };
  }

  // Only add back if not a "Under" case
  updatedRefinements.push(priceRefinement);
  return { pricePart: '', updatedRefinements };
};

const buildBreadcrumbLabel = (refinements, categories, pricePart = '') => {
  const items = [...refinements, ...categories];
  const label = items.length > 0 ? items.join(' - ') : '';

  if (!label && !pricePart) return '';

  return `${label}${pricePart ? ' ' + pricePart : ''} -`;
};

const getRefinedCategories = (categories, refinements) => {
  if (categories.length === 0) {
    return refinements.join(', ');
  }

  let refinedCategories = '';
  let processedRefinements = [...refinements];
  const priceRefinement = processedRefinements.find((refinement) => refinement.includes('$'));
  let { pricePart, updatedRefinements } = applyPriceRefinement(priceRefinement, processedRefinements);

  if (categories.length === 1) {
    if (updatedRefinements.length === 1) {
      refinedCategories = updatedRefinements[0];
    } else if (updatedRefinements.length > 1) {
      refinedCategories = updatedRefinements.filter(Boolean).join(', ');
    } else {
      refinedCategories = categories[0];
    }
  } else if (categories.length > 1) {
    const highlyRatedIndex = updatedRefinements.indexOf('4 & Up');
    if (highlyRatedIndex !== -1) {
      updatedRefinements[highlyRatedIndex] = 'Highly Rated';
    }
    const reversed = updatedRefinements.slice().reverse();
    refinedCategories = `${reversed.join(', ')} ${categories[categories.length - 1]}`.trim();
  }

  if (pricePart) {
    refinedCategories = `${refinedCategories} ${pricePart}`.trim();
  }

  return refinedCategories;
};

const getDepartment = (categories) => {
  let department = '';
  if (categories.length === 0) {
    return department;
  }

  [department] = categories;

  return department;
};

const getTitleCategories = (categories, refinements) => {
  const CONSOLE_TABLE_CATEGORY = 'Console Tables';
  const APPENDED_CONSOLE_TABLE_CATEGORY = 'Console Tables & Sofa Tables';
  const SOFA_BEDS = 'Sofa Beds';
  const APPENDED_SOFA_BEDS = 'Sofa Beds & Sleeper Sofas';

  const titleCategories = categories.slice(-1);

  if (titleCategories[0] === SOFA_BEDS) {
    titleCategories[0] = APPENDED_SOFA_BEDS;
  }

  if (titleCategories[0] === CONSOLE_TABLE_CATEGORY && refinements?.length === 0) {
    titleCategories[0] = APPENDED_CONSOLE_TABLE_CATEGORY;
  }

  return titleCategories;
};

const getBrowseTitleTag = ({ pathWithQueryParams, categories, refinements, searchVal }) => {
  let breadCrumbLabel = 'Browse';
  const isBrowseInSearch = pathWithQueryParams?.indexOf('Ntt-') > -1;
  if (isBrowseInSearch) {
    breadCrumbLabel = `Search Results for ${searchVal} at`;
  } else if (categories?.length >= 0) {
    const titleCategories = getTitleCategories(categories, refinements);
    const furnitureIndex = categories.indexOf('Furniture');
    const pickUpTodayIndex = refinements.indexOf('Pick Up Today');
    let bestRatedRatingIndex = refinements.indexOf('Best Rated');
    let highlyRatedRatingIndex = refinements.indexOf('4 & Up');

    let processedRefinements = [...refinements];

    let priceRefinement = processedRefinements.find((ref) => ref.includes('$'));

    let { pricePart, updatedRefinements } = applyPriceRefinement(priceRefinement, processedRefinements);

    if (bestRatedRatingIndex !== -1) {
      updatedRefinements.splice(bestRatedRatingIndex, 1, 'Best Rated');
      breadCrumbLabel = buildBreadcrumbLabel(updatedRefinements, titleCategories, pricePart);
    } else if (highlyRatedRatingIndex !== -1) {
      updatedRefinements = updatedRefinements.map((ref) => (ref === '4 & Up' ? 'Highly Rated' : ref)
      );
      breadCrumbLabel = buildBreadcrumbLabel(updatedRefinements, titleCategories, pricePart);
    } else if (pickUpTodayIndex !== -1 && furnitureIndex === -1) {
      updatedRefinements.splice(pickUpTodayIndex, 1, 'In Stock Near Me');
      breadCrumbLabel = buildBreadcrumbLabel(updatedRefinements, titleCategories, pricePart);
    } else {
      breadCrumbLabel = buildBreadcrumbLabel(updatedRefinements, titleCategories, pricePart);
    }
  }

  return breadCrumbLabel ? `${breadCrumbLabel} The Home Depot` : 'The Home Depot';
};

export const processBreadcrumbs = (breadcrumbs = []) => {
  const categories = [];
  const refinements = [];
  if (!breadcrumbs || !Array.isArray(breadcrumbs) || breadcrumbs.length === 0) {
    return [categories, refinements];
  }
  breadcrumbs.forEach((crumb) => {
    if (crumb.dimensionName === 'Category') {
      categories.push(crumb.label);
    } else if (crumb.dimensionName === 'Review Rating' && crumb.label === '5') {
      refinements.push('Best Rated');
    } else if (crumb.label !== 'Home') {
      refinements.push(crumb.label);
    }
  });

  return [categories, refinements];
};

export const getDescription = (pageType, categories = [], refinements = [], searchVal, isContentful) => {
  if (pageType !== 'b') return `Search Results for ${searchVal} at The Home Depot`;
  const refinedCategories = getRefinedCategories(categories, refinements);
  const department = getDepartment(categories);

  let description;
  const furnitureIndex = categories.indexOf('Furniture');
  const pickUpTodayIndex = refinements.indexOf('Pick Up Today');
  if (pickUpTodayIndex !== -1 && furnitureIndex === -1 && categories.length > 0) {
    let refinementsWithoutPickUPToday = refinements.filter((refinement) => refinement !== 'Pick Up Today');
    // eslint-disable-next-line max-len
    description = `Find ${refinementsWithoutPickUPToday.reverse().join(', ')} ${categories[categories.length - 1]} ready to be picked up today at your local Home Depot store.`;
    return description;
  }
  // Major Appliances no longer offers free shipping, so we need to update the description for these pages
  if (categories[0] === 'Appliances' && pageType === 'b') {
    const majorAppliancesDescription = `Browse our online aisle of ${refinedCategories}. `
      + `Shop The Home Depot for all your ${department} and DIY needs.`;
    return majorAppliancesDescription;
  }
  description = `Get free shipping on qualified ${refinedCategories} products or Buy Online Pick Up in Store today`;
  if (department) {
    description += ` in the ${department} Department`;
  }
  if (isContentful) {
    // eslint-disable-next-line max-len
    description = `Shop ${refinedCategories} and more at The Home Depot. We offer free delivery, in-store and curbside pick-up for most items`;
  }
  description = `${description}.`;
  return description;
};

export const getTitleTag = ({
  pageType,
  categories = [],
  refinements = [],
  searchVal,
  pathWithQueryParams,
}) => {
  switch (pageType) {
  case 'b':
    return getBrowseTitleTag({
      pathWithQueryParams,
      categories,
      refinements,
      searchVal
    });

  case 's':
    return `Search Results for ${searchVal} at The Home Depot`;
  default:
    return 'The Home Depot';
  }
};

export const getnValue = (canonical) => {
  if (!canonical) return null;
  const result = /N-(\w+)/.exec(canonical);
  if (result && result.length) {
    return result[1];
  }
  return null;
};

export const parseCrumbs = (crumbs = [], keyword, returnAll = false) => {
  if (keyword) {
    const textSearchCrumb = {
      url: '',
      label: 'Text Search'
    };

    let label;
    try {
      label = decodeURI(keyword);
    } catch (error) {
      label = keyword;
    }
    const keywordCrumb = {
      url: `/s/${keyword}?NCNI-5`,
      label
    };
    if (!crumbs.length) {
      crumbs.unshift(textSearchCrumb, keywordCrumb);
    } else {
      const textSearchCrumbIndex = crumbs.findIndex((crumb) => {
        return crumb.label === textSearchCrumb.label;
      });
      if (textSearchCrumbIndex === -1) {
        crumbs.unshift(textSearchCrumb, keywordCrumb);
      }
    }
  }
  if (crumbs.length > 0) {
    const hasCategory = crumbs.filter((crumb) => (crumb.dimensionName || '').toLowerCase() === 'category').length > 1;
    const breadcrumbs = hasCategory && !returnAll
      ? crumbs.filter((crumb) => (crumb.dimensionName || '').toLowerCase() === 'category')
      : crumbs.filter((crumb) => !crumb.deselectUrl);
    return breadcrumbs.map((crumb) => normalizeBreadcrumb(crumb));
  }
  return [];
};

export const removeSpecialCharacters = (string) => {
  return string.replace(/[&/\\#,+()$~%.'":*?<>{}]/g, '');
};

export const addSpaceForBreakTag = (string = '') => {
  return string?.replace(/<\s?br\s?\/?>/g, ' ');
};

// https://ourcodeworld.com/articles/read/376/how-to-strip-html-from-a-string-extract-only-text-content-in-javascript
export const stripHtml = (string = '') => {
  return string?.replace(/<[^>]+>/g, '');
};

export const getAllowedNoFollow = (pathWithQueryParams, canonicalUrl) => {
  const allLowercaseQuery = pathWithQueryParams?.toLowerCase();
  const allowedUpperbound = /upperbound=(?:100|(?:2[05]|[3-6]0))0[&/]?$/;
  const upperbound = allLowercaseQuery?.split('&')?.filter(((element) => element.match(allowedUpperbound)));
  if (
    allLowercaseQuery?.indexOf('/b/furniture-living-room-furniture-sofas-couches') > -1
    && (allLowercaseQuery?.indexOf('lowerbound=0') > -1 && upperbound?.length)) {
    return false;
  }

  const noFollow = canonicalUrl?.indexOf('NCNI-5') > -1
    || pathWithQueryParams?.indexOf('NCNI-5') > -1
    || pathWithQueryParams?.indexOf('Ns=P_Topseller_Sort%7C1') > -1
    || pathWithQueryParams?.indexOf('Ns=P_Smartsort%7C1') > -1
    || pathWithQueryParams?.indexOf('Ns=P_REP_PRC_MODE%7C0') > -1
    || pathWithQueryParams?.indexOf('Ns=P_REP_PRC_MODE%7C1') > -1
    || pathWithQueryParams?.indexOf('Ns=P_Top_Rated_Sort%7C1') > -1
    || pathWithQueryParams?.indexOf('sortorder=') > -1
    || pathWithQueryParams?.indexOf('sortby=') > -1
    || pathWithQueryParams?.indexOf('Ntk-') > -1
    || pathWithQueryParams?.indexOf('/b/Featured-Products') > -1
    || pathWithQueryParams?.indexOf('Ntt-') > -1
    || allLowercaseQuery?.indexOf('lowerbound=') > -1
    || allLowercaseQuery?.indexOf('upperbound=') > -1;

  return noFollow;
};
